function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getWebApp } from '@client/lib/Telegram';
import { canUseDOM } from '@lib/canUseDOM';
import { CommonConst } from '@const/index';
import { useHistoryManager } from '@client/lib/HistoryManager';
export var PagePropsContext = /*#__PURE__*/React.createContext({});
var isFirst = true;
export function usePageProps(options) {
  var _ref, _options$getUniqueKey;
  // На сервере у нас есть только одни данные, используем только их и забиваем на всю клиентскую логику
  if (!canUseDOM) {
    var dataset = React.useContext(PagePropsContext);
    return {
      data: dataset,
      loading: false
    };
  }
  var cacheManager = useHistoryManager();
  var cached = cacheManager.getPageData();
  var navigate = useNavigate();
  var params = useParams();

  // Идентификатор данных (запроса)
  var _React$useState = React.useState((_ref = window.__initialData__) !== null && _ref !== void 0 ? _ref : cached === null || cached === void 0 ? void 0 : cached.props),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    data = _React$useState2[0],
    setData = _React$useState2[1];
  var _React$useState3 = React.useState(data === undefined),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    loading = _React$useState4[0],
    setLoading = _React$useState4[1];
  var uniqueKey = options === null || options === void 0 || (_options$getUniqueKey = options.getUniqueKey) === null || _options$getUniqueKey === void 0 ? void 0 : _options$getUniqueKey.call(options, params);
  React.useEffect(function () {
    var destructor = function destructor() {
      setData(undefined);
      setLoading(true);
    };
    if (isFirst) {
      isFirst = false;
      cacheManager.setPageData({
        path: window.location.pathname,
        props: window.__initialData__,
        params: _objectSpread({}, window.RentApp)
      });

      // @ts-expect-error Считаем, что initialData есть всегда, но после первого рендера он нам не нужен
      window.__initialData__ = undefined;
      return destructor;
    }
    function onPageLoaded(res) {
      var _res$params, _res$props$pageInfo;
      if ((_res$params = res.params) !== null && _res$params !== void 0 && _res$params.redirect) {
        navigate(res.params.redirect);
        return;
      }
      if ((_res$props$pageInfo = res.props.pageInfo) !== null && _res$props$pageInfo !== void 0 && _res$props$pageInfo.title) {
        document.title = "".concat(CommonConst.projectName, " | ").concat(res.props.pageInfo.title);
      }
      setData(res.props);
      setLoading(false);
      cacheManager.setPageData(res);
    }
    if (cached) {
      onPageLoaded(cached);
      return;
    }
    setLoading(true);
    var fd = new FormData();
    var url = new URL(location.href, "".concat(window.location.protocol, "//").concat(window.location.host));
    url.searchParams.append('ajax', '1');
    if (getWebApp().initData) {
      fd.append('userdata', getWebApp().initData);
    }
    void fetch(url.toString(), {
      method: 'POST',
      body: fd
    }).then(function (res) {
      return res.json();
    }).then(onPageLoaded);
    return destructor;
  }, [uniqueKey, cacheManager]);
  return {
    data: data,
    loading: loading
  };
}